import firebase from 'firebase/compat/app'
import 'firebase/compat/functions'
import 'firebase/compat/database'
import { CircularProgress } from '@mui/material'
import { getAnalytics } from 'firebase/analytics'

const isPreview = process.env.REACT_APP_PREVIEW === 'true'

let databaseUrl = isPreview
  ? 'https://previewdbhalkan.europe-west1.firebasedatabase.app/'
  : 'https://halkan-e457e-default-rtdb.europe-west1.firebasedatabase.app/'

const app = firebase.initializeApp({
  apiKey: 'AIzaSyDGcxLLVQCZRD9FzmbiAvCHOhi7-3QanD0',
  authDomain: 'halkan-e457e.firebaseapp.com',
  databaseURL: databaseUrl,
  projectId: 'halkan-e457e',
  storageBucket: 'halkan-e457e.appspot.com',
  messagingSenderId: '561252608050',
  appId: '1:561252608050:web:7441fc91126331cee9342b',
  measurementId: 'G-MM8RFYWJQH'
})

const functions = firebase.app().functions('europe-west1')
const database = firebase.database()
//functions.useEmulator("127.0.0.1", "5001")
//database.useEmulator("127.0.0.1", "9000")

export const getFunctions = () => functions
export const getRTDatabase = () => database

export const analytics = getAnalytics(app)

export default app

export function LoadingScreen () {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center'
      }}
    >
      <div>
        <CircularProgress size={100} color={'success'} />
      </div>
    </div>
  )
}
